import { SiteSettingsContextValue } from "context/SiteSettingsContext/types";

export type ITechspecsRouteParams = Parameters<
  SiteSettingsContextValue["routes"]["techSpecs"]
>[0];

export const buildLearnMoreRoute = (
  routes: SiteSettingsContextValue["routes"],
  link?: ITechspecsRouteParams,
) => {
  if (!link) {
    return undefined;
  }

  return routes.techSpecs({
    path: link.path,
    searchParams: link?.searchParams,
  });
};
